import { lazy } from "react";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";

import { Navigate } from "react-router-dom";

const Soon = lazy(() => import(".."));

const securityRoute = {
  icon: DirectionsCarIcon,
  name: "Trip Management",
  link: "/trip-management",
  path: "trip-management",
  index: 8,
  element: "",
  superAdminView: false,
  children: [
    {
      path: "employee-shifts",
      element: <Soon />,
      permission: "Trip Requests-Read",
      name: "Employee Shifts",
      index: 5,
      link: "trip-management/employee-shifts",
      icon: CalendarMonthIcon,
    },
    {
      path: "",
      element: <Navigate to="trip-request" replace />,
    },
  ],
};
export default securityRoute;
